<template>
  <div class="center">
    <template v-if="loading">
      <loader
        message-id="loading"
        position-center />
    </template>
    <template v-if="tvl.length > 0">
      <g-chart
        type="PieChart"
        :settings="{ packages: ['corechart'] }"
        :options="options"
        :resize-debounce="500"
        :data="chart"
      />
    </template>
    <template v-else>
      <a-empty :description="'historical-tvl.empty-data' | globalize" />
    </template>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts/legacy'
import { ErrorHandler } from '@/js/helpers/error-handler'
import { clearObject } from '@/js/helpers/clear-object'
import TvlMixin, { tvlTypesAsObject } from '@/vue/mixins/tvl.mixin'
import { api } from '@/api'
import Loader from '@/vue/common/Loader'
import AEmpty from 'ant-design-vue/lib/empty'

export default {
  name: 'total-tvl',
  components: {
    GChart,
    Loader,
    AEmpty,
  },

  mixins: [TvlMixin],
  props: {
    tvlType: {
      type: String,
      required: true,
      default: tvlTypesAsObject.token_tvl,
    },
    title: {
      type: String,
      required: true,
      default: 'Summary',
    },
  },

  data () {
    return {
      ...this.data,
      options: {
        width: 400,
        height: 200,
        title: this.title,
      },
    }
  },

  computed: {
    chart () {
      const result = this.convertToChartData()
      return result
    },
  },

  async created () {
    await this.getTotalTvl()
  },
  methods: {
    async getTotalTvl () {
      this.loading = true

      try {
        const query = clearObject({
          'filter[symbol]': this.filters.symbol,
          'page[limit]': 10000,
        })
        const response = await api.getWithSignature(`/tvl/total/${this.tvlType}/${this.network.chainId}`, query)

        this.tvl = response.data && response.data.forEach ? response.data : []
      } catch (e) {
        ErrorHandler.processWithoutFeedback(e)
      } finally {
        this.loading = false
      }
    },

    convertToChartData () {
      // https://developers.google.com/chart/interactive/docs/gallery/piechart
      // var data = google.visualization.arrayToDataTable([
      //   ['Task', 'Hours per Day'],
      //   ['Eat',      2],
      // ]);
      const chart = [
        ['Token', 'Usd Value'],
      ]
      this.tvl.forEach(row => {
        chart.push([row.symbol, row.usdValue])
      })

      return chart
    },
  },
}
</script>

<style scoped>
  @import '~ant-design-vue/lib/empty/style/index.css';

  .center {
    margin: auto;
    width: 40%;
  }
</style>
